import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { User } from '@angular/fire/auth';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  user: User | null = null;
  public active: boolean = false;

  constructor(
    private _authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Suscripción reactiva: se actualiza automáticamente cuando cambia el estado de auth
    this._authService.user$.subscribe(user => {
      this.user = user;
    });
  }

  async onLogOut() {
    await this._authService.signOut();
    this.router.navigate(['/login']);
  }

  setActive() {
    this.active = !this.active;
  }
}
